import { createAction, props } from '@ngrx/store';

export const USER_SET_ME = '[USER][SET]::[Me]';
export const USER_RESET_ALL = '[USER][RESET]::[All]';

export const SetMe = createAction(
  USER_SET_ME,
  props<{
    email: string;
    first_name: string;
    last_name: string;
    roles: string[];
  }>()
);
export const ResetAll = createAction(USER_RESET_ALL);
